module.exports = __webpack_public_path__ + "static/media/nfr.763dccd3.md";